export default function updateCard() {
  const modal = document.querySelector(".modal");
  const $form__UpdateMethod = $(".js-stripe-form__update");

  if ($form__UpdateMethod.length) {
    const form__UpdateMethod = document.getElementById("payment-form__update");
    if (!form__UpdateMethod) {
      return;
    }

    const stripe__UpdateMethod = window.Stripe(
      $form__UpdateMethod.attr("data-stripe-publishable-key")
    );
    const clientSecret__UpdateMethod = form__UpdateMethod.dataset.secret;
    const elements__UpdateMethod = stripe__UpdateMethod.elements({
      clientSecret: clientSecret__UpdateMethod,
      fonts: [
        {
          cssSrc: "https://fonts.googleapis.com/css?family=Roboto:400",
        },
      ],
    });

    const paymentElement__UpdateMethod = elements__UpdateMethod.create(
      "payment",
      {
        layout: "tabs",
        paymentMethodOrder: ["card"],
        terms: {
          card: "never",
        },
      }
    );
    const billingAddressElement__UpdateMethod = elements__UpdateMethod.create(
      "address",
      {
        mode: "billing",
      }
    );

    paymentElement__UpdateMethod.mount("#payment-element");
    billingAddressElement__UpdateMethod.mount("#billing-address-element");

    paymentElement__UpdateMethod.on("change", (event) => {
      setFieldError(
        "#payment-element-field-errors",
        event.error && event.error.message
      );
    });

    billingAddressElement__UpdateMethod.on("change", (event) => {
      setFieldError(
        "#billing-address-field-errors",
        event.error && event.error.message
      );
    });

    const submitButton__UpdateMethod = document.querySelector(
      ".js-stripe-submit__update"
    );
    if (!submitButton__UpdateMethod) {
      return;
    }

    const validateBillingAddress = async () => {
      const addressResult =
        await billingAddressElement__UpdateMethod.getValue();
      if (addressResult.complete) {
        setFieldError("#billing-address-field-errors", null);
        return true;
      }

      setFieldError(
        "#billing-address-field-errors",
        "Please complete your billing address"
      );
      return false;
    };

    form__UpdateMethod.addEventListener("submit", async function (ev) {
      ev.preventDefault();

      const validAddress = await validateBillingAddress();

      if (!validAddress) {
        if (modal) {
          modal.scrollTo(0, 0);
        }
        return false;
      }

      submitButton__UpdateMethod.setAttribute("disabled", "disabled");
      submitButton__UpdateMethod.innerHTML = "<span>Saving...</span>";

      const submitResult = await elements__UpdateMethod.submit();
      if (submitResult.error) {
        const errors = $("#card-errors__update");
        errors
          .addClass("form-error-field")
          .empty()
          .append(
            submitResult.error.message ||
              "We're sorry but your update was unsuccessful, please check your card details or contact your bank"
          );

        submitButton__UpdateMethod.removeAttribute("disabled");
        submitButton__UpdateMethod.innerHTML = `<span>${submitButton__UpdateMethod.dataset.originalTitle}</span>`;
        return;
      }

      const addressResult =
        await billingAddressElement__UpdateMethod.getValue();

      const confirmationResult = await stripe__UpdateMethod.confirmSetup({
        elements: elements__UpdateMethod,
        confirmParams: {
          payment_method_data: {
            billing_details: {
              name: (addressResult.value || {}).name || undefined,
              address: normalisedAddress((addressResult.value || {}).address),
            },
          },
        },
        redirect: "if_required",
      });

      let setupIntent = confirmationResult.setupIntent;
      if (!setupIntent) {
        const retrieveResult = await stripe__UpdateMethod.retrieveSetupIntent(
          clientSecret__UpdateMethod
        );
        setupIntent = retrieveResult.setupIntent;
      }

      if (confirmationResult.error) {
        const errors = $("#card-errors__update");
        errors
          .addClass("form-error-field")
          .empty()
          .append(
            confirmationResult.error.message ||
              "We're sorry but your update was unsuccessful, please check your card details or contact your bank"
          );

        submitButton__UpdateMethod.removeAttribute("disabled");
        submitButton__UpdateMethod.innerHTML = `<span>${submitButton__UpdateMethod.dataset.originalTitle}</span>`;
      } else if (setupIntent && setupIntent.status === "succeeded") {
        $(".js-stripe-payment-method-id__update").val(
          setupIntent.payment_method
        );
        $form__UpdateMethod.submit();
      } else {
        const errors = $("#card-errors__update");
        errors
          .addClass("form-error-field")
          .empty()
          .append("We could not verify your card update. Please try again.");

        submitButton__UpdateMethod.removeAttribute("disabled");
        submitButton__UpdateMethod.innerHTML = `<span>${submitButton__UpdateMethod.dataset.originalTitle}</span>`;
      }
    });
  }

  function normalisedAddress(address) {
    const addressData = address || {};
    return {
      line1: addressData.line1 || undefined,
      line2: addressData.line2 || undefined,
      city: addressData.city || undefined,
      state: addressData.state || undefined,
      postal_code:
        addressData.postal_code || addressData.postalCode || undefined,
      country: addressData.country || undefined,
    };
  }

  function setFieldError(selector, message) {
    const $displayError = $(selector);
    if (message) {
      $displayError.text(message);
    } else {
      $displayError.empty();
    }
  }
}
